export const backendApi = process.env.REACT_APP_RPC_URL;
export const USDC_MINT = process.env.REACT_APP_USDC_MINT;
export const SAN_MINT = process.env.REACT_APP_SAN_MINT;
export const CLUSTER = process.env.REACT_APP_CUSTER;
